import { Search } from '@mui/icons-material'
import { Box, MenuItem, TextField } from '@mui/material'
import { useTranslate } from 'ra-core'

interface ModelListFiltersProps {
    searchFilter: string
    setSearchFilter: (value: string) => void
    statusFilter: string
    setStatusFilter: (value: string) => void
}

export const ModelListFilters: React.FC<ModelListFiltersProps> = ({
    searchFilter,
    setSearchFilter,
    statusFilter,
    setStatusFilter
}) => {
    const translate = useTranslate()

    return (
        <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" pb={0.5}>
            <TextField
                label={translate('manager.resources.general.search')}
                variant="outlined"
                size="small"
                value={searchFilter}
                onChange={(e) => setSearchFilter(e.target.value)}
                InputProps={{
                    endAdornment: <Search />
                }}
                sx={{ minWidth: 250 }}
            />

            <TextField
                select
                label={translate('manager.resources.model_manager.status')}
                variant="outlined"
                size="small"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                sx={{ minWidth: 150 }}
            >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="published">Published</MenuItem>
                <MenuItem value="unpublished">Pending changes</MenuItem>
            </TextField>
        </Box>
    )
}
